import React from 'react'

const AboutUs = () => {
  return (
    <div>
      <div className="page-header-about parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                     About Us
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us.html" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us.html" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="about-us">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-lg-6">
            {/* About Us Images Start */}
            <div className="about-us-images">
              {/* About Image 1 */}
              <div className="about-img-1">
                <figure className="image-anime reveal">
                 <img src="imgs/premier-interior-design.jpg" alt="Premier Interior Design " />
                </figure>
              </div>

              {/* About Image 2 */}
              <div className="about-img-2">
                <figure className="image-anime reveal">
                  <img src="imgs/premier-interior-design-mehome.jpg" alt="Premier Interior Design " />
                </figure>

                {/* Experience Counter */}
                <div className="experience-counter">
                  <h3>
                    <span className="counter">6</span>+
                  </h3>
                  <p>Years of experience</p>
                </div>
              </div>

              {/* Feedback Counter */}
              <div className="feedback-counter">
                <p>
                  <span className="counter">95</span>%
                </p>
                <h3>positive feedback</h3>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6">
            <div className="about-us-content">
              {/* Section Title */}
              <div className="section-title">
                <h3 className="wow fadeInUp">MeHome - About us</h3>
                <h2
                  className="text-anime-style-2"
                  data-cursor="-opaque"
                >
                  Premier Interior Design &{" "}
                  <span>Construction Services</span>
                </h2>
                <p
                  className="wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  At MeHome, we redefine the way spaces are designed, built,
                  and experienced. With 6+ years of expertise in the interior
                  design and construction industry, we have successfully
                  delivered projects that balance creativity, functionality,
                  and precision engineering. Our goal is simple: to craft
                  spaces that truly reflect the personality, values, and
                  aspirations of our clients.
                </p>
              </div>

              {/* About Us Content Body */}
              <div className="about-us-content-body">
                <div className="about-us-content-info">
                  {/* About Us Content List 1 */}
                  <div
                    className="about-us-content-list wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <ul>
                      <li>Residential Interiors</li>
                      <li>Commercial & Corporate Spaces</li>
                      <li>Renovations & Space Makeovers</li>
                    </ul>
                  </div>
                </div>

                {/* About Us Content List 2 */}
                <div className="about-us-contact-list">
                  <div
                    className="about-us-content-list wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <ul>
                      <li>Construction & Turnkey Solutions</li>
                      <li>Modular Kitchens & Custom Furniture</li>
                    </ul>
                  </div>

                  <div
                    className="about-us-content-btn wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <a href="about.html" className="btn-default">
                      read more
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default AboutUs
